<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>
                    {{ $t('org.billing.Resource') }}
                </h4>
            </div>
            <a
                data-action="collapse"
                :class="{ rotate: isCollapsed }"
                @click="triggerCollapse"
                class="mr-2"
            >
                <feather-icon
                    icon="ChevronDownIcon"
                    size="16"
                />
            </a>
        </div>
        <b-alert
            :show="showDismissibleFilter"
            variant="info"
            dismissible
            @dismissed="dismissed"
        >
            <div class="alert-body">
                <feather-icon
                    icon="SearchIcon"
                />
                {{ value }}
            </div>
        </b-alert>
        <b-collapse
            v-model="visible"
            :visible="visible"
            class="card-content"
        >
            <b-table-simple
                v-if="data.length !== 0"
                sticky-header
            >
                <b-tbody>
                    <b-tr v-for="(item, index) in data" :key="index">
                        <b-td style="word-break:break-all;">
                            <a href="javascript:;" @click="handleLabelClick(item.key)">
                                {{ item.key }}
                            </a>
                        </b-td>
                        <b-td class="text-right text-nowrap" style="width:30%;">
                            {{ $_getDollar(item.cost) }}
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-collapse>
        <hr class="mt-0">
        <h4 class="pb-50 text-center">
            {{ data.length }}
            <small>
                / {{ $_getNumberFormat(count, 0) }} {{ $t('v4.total resources') }}
            </small>
        </h4>
    </b-card>
</template>

<script>
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import { toRefs, ref, watch } from '@vue/composition-api'
export default {
    props: {
        field: {
            type: String
        },
        count: {
            type: Number,
            default: 0
        },
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const { changeProject } = useSelectProjectAndGroup()
        const { field } = toRefs(props)
        const visible = ref(false)
        const isCollapsed = ref(false)
        const showDismissibleFilter = ref(false)
        const value = ref('')
        const triggerCollapse = () => {
            visible.value = !visible.value
        }
        const handleLabelClick = (data) => {
            showDismissibleFilter.value = true
            value.value = data
            context.emit('filter:items', { field: field.value, value: [data] })
        }
        const handlerResetValue = () => {
            showDismissibleFilter.value = false
            value.value = undefined
            context.emit('filter:items', { field: field.value, value: undefined })
        }
        const dismissed = () => {
            if (!value.value) return
            handlerResetValue()
        }
        watch(changeProject, (_) => {
            value.value = undefined
            showDismissibleFilter.value = false
        })
        return {
            dismissed,
            visible,
            isCollapsed,
            showDismissibleFilter,
            value,
            triggerCollapse,
            handleLabelClick,
            handlerResetValue
        }
    }
}
</script>

<style>

</style>
